import * as React from "react";
import { RecommendationCell } from "./StatusIcon";

interface Props {
  result: ClientSiteAssessmentResultsDTO;
}

export const InofficeRecommendationCell: React.FC<Props> = ({ result }) => (
  <RecommendationCell
    status={result.careRecommendation}
    dateCompleted={result.careDateCompleted}
    testId={result.careTestResultId}
  />
);
